import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user']),
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover esta pessoa da undiade <b>${this.currentEntity.unit.number}</b>?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dweller/livings/resources/computed.js